import charts from '../../charts.js';
import indicatorsChart from '../indicators.js';

export default function({ id, data, config, dates }) {
	if (!config.extra) {
		config.extra = [];
	}

	config.extra.push({
		title: 'Federal Balance Sheet',
		dataKey: 'fed',
	});

	const chart = indicatorsChart({ id, data, config, dates });

// 	const { panel, xAxis, yAxis } = chart.addPanel();
//
// 	chart.addSeries(
// 		chart.lineSeries(
// 			{
// 				legendLabelText: 'Histogram',
// 				valueYField: 'histogram',
// 			},
// 			yAxis,
// 			xAxis
// 		),
// 		panel
// 	);

	return chart;

// 	settings.panels[0].stockGraphs.push(
// 		charts.lineGraph({
// 			id: 'fed',
// 			title: 'Federal Balance Sheet',
// 			valueField: 'fed',
// 			valueAxis: 'fed',
// 			lineColor: charts.colours.blue,
// 		})
// 	);
//
// 	settings.panels[0].valueAxes = [
// 		... settings.panels[0].valueAxes,
// 		{
// 			position: 'right',
// 			id: 'fed',
// 			synchronizeWith: 'default',
// 			gridCount: 0,
// 			gridAlpha: 0,
// 			gridThickness: 0,
// 			usePrefixes: true,
// 		},
// 	];
//
// 	settings.panels.push({
// 		id: 'histogram',
// 		percentHeight: 33,
// 		stockGraphs: [
// 			charts.lineGraph({
// 				id: 'histogram',
// 				title: 'Histogram',
// 				fillAlphas: 0.15,
// 				valueField: 'histogram',
// 				fillColors: charts.colours.green,
// 				lineColor: charts.colours.green,
// 				negativeFillColors: charts.colours.red,
// 				negativeLineColor: charts.colours.red,
// 				negativeBase: 0,
// 			}),
// 		],
// 	});
//
// 	return settings;
}
